<template>
<button
  v-if="$can('events.view.presenter')"
  @click="clickOpenPresenter()"
  class="btn btn-fill btn-wd btn-success btn-block btn-router"
>
  Abrir apresentador
</button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BtnOpenNewPresenter',

  computed: {
    ...mapGetters('events', {
      event: 'event'
    }),

    presenter () {
      return process.env.HOST_PRESENTER
    }
  },

  methods: {
    clickOpenPresenter () {
      window.open(
        `${this.presenter}/#/${this.event._id}`,
        'Presenter Window',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false,toolbar=false,fullscreen=yes'
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnOpenNewPresenter.vue